module.exports = __webpack_public_path__ + "static/video-poster-full-3c6acbb2bcb95825a13a98f053f7899c.jpg";